<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <!-- <transition name="sidebarLogoFade">
      <router-link
        v-if="collapse"
        key="collapse"
        class="sidebar-logo-link"
        to="/"
      >
        <img v-if="logo" :src="logoUrl" class="sidebar-logo" />
        <h1 v-else class="sidebar-title">{{ brandName }}</h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logoUrl" class="sidebar-logo" />
        <h1 class="sidebar-title">{{ brandName }}</h1>
      </router-link>
    </transition>-->
    <div class="sidebar-logo-link">
      <img :src="logoUrl" class="sidebar-logo" alt />
      <h1
        class="sidebar-title break-word"
        :title="brandTotalName"
        v-show="!collapse"
      >{{ brandName }}</h1>
      <i
        class="icon iconfont iconqiehuan1"
        v-show="hierarchyType === 'GS' && !collapse && brandList.length > 1"
        @click="showBrandSwitchingDialog"
      ></i>
    </div>
    <BrandSwitchingDialog
      v-if="brandSwitchingDialogShow"
      @on-close="closeBrandSwitchingDialog"
      @sure="sureBrandSwitchingDialog"
      :brandId="brandId"
    ></BrandSwitchingDialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { IMG_SERVE_URL } from '@/config'
import { isEmpty } from '@/utils/index'
import BrandSwitchingDialog from '@/components/brandSwitchingDialog'
// const logoPic = require('../../../assets/images/hy-logo.png')
export default {
  inject: ['reload'],
  components: {
    BrandSwitchingDialog
  },
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'brandInfo',
      'hierarchyType',
      'brandList',
      'navList',
      'userInfo',
      'isOpenGxms'
    ]),
    logoUrl() {
      if (isEmpty(this.brandInfo.logoUrl)) {
        let host = location.host
        // if (host.indexOf('zwot') > -1) {
        //   return require('../../../assets/images/cx-logo.png')
        // } else {
        //   return require('../../../assets/images/hy-logo.png')
        // }
        if (host === 'wk.hyunst.com') {
          return require('../../../assets/images/hy-logo.png')
        } else if (host === 'wk.zwot.cn') {
          return require('../../../assets/images/cx-logo.png')
        } else if (host === 'sh.zwot.cn') {
          return require('../../../assets/images/ttd-logo.png')
        } else {
          return require('../../../assets/images/hy-logo.png')
        }
        // return require('../../../assets/images/cx-logo.png')
        // return logoPic
      } else {
        return IMG_SERVE_URL + this.brandInfo.logoUrl
      }
    },
    brandName() {
      let titleName = ''
      if (this.isOpenGxms) {
        titleName = this.userInfo.name || ''
      } else {
        titleName = this.brandInfo.name || ''
      }
      if (titleName.length > 7) {
        titleName = titleName.substring(0, 7)
      }
      return titleName
    },
    brandId() {
      return this.brandInfo.id
    },
    brandTotalName() {
      let titleName = ''
      if (this.isOpenGxms) {
        titleName = this.userInfo.name || ''
      } else {
        titleName = this.brandInfo.name || ''
      }
      return titleName
    }
  },
  data() {
    return {
      title: 'Vue Admin Template',
      //  logo: 'https: //  wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png'
      logo: '../../../assets/images/haoyun-logo.png',
      brandSwitchingDialogShow: false
    }
  },
  methods: {
    ...mapActions(['getBrandById']),
    showBrandSwitchingDialog() {
      this.brandSwitchingDialogShow = true
    },
    closeBrandSwitchingDialog() {
      this.brandSwitchingDialogShow = false
    },
    async sureBrandSwitchingDialog(id) {
      if (id !== this.brandId) {
        const loading = this.$loading({
          lock: true,
          text: '拼命加载中。。。'
        })
        await this.getBrandById(id)
        loading.close()
        this.$message({
          type: 'success',
          message: '切换品牌成功'
        })
        let pathName = ''
        if (this.navList.length === 0) {
          pathName = '/'
        } else {
          if (this.navList[0].children && this.navList[0].children.length > 0) {
            pathName =
              this.navList[0].url + '/' + this.navList[0].children[0].url
          } else {
            pathName = this.navList[0].url
          }
        }
        this.$router.push({
          path: pathName
        })
        // this.$router.push({
        //   name: 'Home'
        // })
        this.$nextTick(() => {
          this.reload()
        })
      }
      this.brandSwitchingDialogShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    text-align: left;
    padding: 15px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;

    & .sidebar-logo {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      //  font-size: 14px;
      font-size: 20px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
      flex: 1;
    }
    & .iconqiehuan1 {
      font-size: 12px;
      background: #bfcbd9;
      color: #474c58;
      height: 20px;
      width: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 3px;
      font-weight: bold;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
